import React, {
  useEffect,
  useState,
} from "react";

import SearchBarDropdown from "./SearchBarDropdown";
import SearchBarDropdownMobile from "./SearchBarDropdownMobile";

export default function ResponsiveSearchBarDropdown(
  props
) {
  const [isMobile, setIsMobile] =
    useState(window.innerWidth <= 768);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(
      window.innerWidth <= 768
    );
  };

  handleResize();

  window.addEventListener(
    "resize",
    handleResize
  );

  return () =>
    window.removeEventListener(
      "resize",
      handleResize
    );
}, []);



  return isMobile ? (
    <SearchBarDropdownMobile
      {...props}
    />
  ) : (
    <SearchBarDropdown {...props} />
  );
}